import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "dialog-footer"
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode("取 消");

var _hoisted_3 = /*#__PURE__*/_createTextVNode("确 定");

import { ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['updateOption'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var dialogVisible = ref(props.options.visible);

    var updateOptionVisible = function updateOptionVisible(value) {
      emits('updateOption', 'visible', value);
    };

    watch(function () {
      return props.options.visible;
    }, function (newVal) {
      if (newVal) {
        dialogVisible.value = true;
      }
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return __props.options.visible ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return dialogVisible.value = $event;
        }),
        width: __props.options.width || '60%',
        title: __props.options.title,
        "close-on-click-modal": false,
        onOpen: _cache[3] || (_cache[3] = function ($event) {
          return updateOptionVisible(true);
        }),
        onClose: _cache[4] || (_cache[4] = function ($event) {
          return updateOptionVisible(false);
        })
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return updateOptionVisible(false);
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_2];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            loading: __props.options.loading,
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.$emit('onDialogSubmit');
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }, 8, ["loading"])])];
        }),
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 3
      }, 8, ["modelValue", "width", "title"])) : _createCommentVNode("", true);
    };
  }
});